import Vue, { PluginObject } from 'vue';
import { humanizeNumber } from '@aretheyhappy/utils';
import * as MeadCommon from '../dist';
import type { IMeadCore } from '../dist';
export {MeadCommon};

type ComponentKeyMapping = {
    key: string,
    comp: any,
}

//
// Components -> Atoms -> entities
//

import HierarchyType from './components/atoms/entities/HierarchyType.vue';
import LocationType from './components/atoms/entities/LocationType.vue';
export {HierarchyType, LocationType}
const ATOMS_ENTITIES_COMP_MAP = [
    {key: 'mead-hierarchy-type', comp: HierarchyType},
    {key: 'mead-location-type', comp: LocationType},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> Atoms -> forms
//

import FormCheckbox from './components/atoms/forms/FormCheckbox.vue';
import FormCheckboxList from './components/atoms/forms/FormCheckboxList.vue';
import FormColor from './components/atoms/forms/FormColor.vue';
import FormColorList from './components/atoms/forms/FormColorList.vue';
import FormDatePicker from './components/atoms/forms/FormDatePicker.vue';
import FormFiles from './components/atoms/forms/FormFiles.vue';
import FormInput from './components/atoms/forms/FormInput.vue';
import FormLabel from './components/atoms/forms/FormLabel.vue';
import FormMedia from './components/atoms/forms/FormMedia.vue';
import FormNumber from './components/atoms/forms/FormNumber.vue';
import FormOptions from './components/atoms/forms/FormOptions.vue';
import FormRadioButtonList from './components/atoms/forms/FormRadioButtonList.vue';
import FormSearch from './components/atoms/forms/FormSearch.vue';
import FormSelect from './components/atoms/forms/FormSelect.vue';
import FormTextarea from './components/atoms/forms/FormTextarea.vue';
import FormTimepicker from './components/atoms/forms/FormTimepicker.vue';
export {
    FormCheckbox, FormCheckboxList, FormColor, FormColorList,
    FormDatePicker, FormFiles, FormInput, FormLabel, FormMedia,
    FormNumber, FormOptions, FormRadioButtonList, FormSearch,
    FormSelect, FormTextarea, FormTimepicker
}
const ATOMS_FORMS_COMP_MAP = [
    {key: 'mead-form-checkbox', comp: FormCheckbox},
    {key: 'mead-form-checkbox-list', comp: FormCheckboxList},
    {key: 'mead-form-color', comp: FormColor},
    {key: 'mead-form-color-list', comp: FormColorList},
    {key: 'mead-form-date-picker', comp:  FormDatePicker},
    {key: 'mead-form-files', comp: FormFiles},
    {key: 'mead-form-input', comp: FormInput},
    {key: 'mead-form-label', comp: FormLabel},
    {key: 'mead-form-media', comp: FormMedia},
    {key: 'mead-form-number', comp: FormNumber},
    {key: 'mead-form-options', comp: FormOptions},
    {key: 'mead-form-radio-button-list', comp: FormRadioButtonList},
    {key: 'mead-form-search', comp: FormSearch},
    {key: 'mead-form-select', comp: FormSelect},
    {key: 'mead-form-textarea', comp: FormTextarea},
    {key: 'mead-form-timepicker', comp: FormTimepicker},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> Atoms -> stencils
//

import LoadingStencil from './components/atoms/stencils/LoadingStencil.vue';
export {LoadingStencil}
const ATOMS_STENCILS_COMP_MAP = [
    {key: 'mead-loading-stencil', comp: LoadingStencil}
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> Atoms -> visuals
//

import Badge from './components/atoms/visuals/Badge.vue';
import Breakdown from './components/atoms/visuals/Breakdown.vue';
import Dot from './components/atoms/visuals/Dot.vue';
import EntityTitle from './components/atoms/visuals/EntityTitle.vue';
import EntityTitleStencil from './components/atoms/visuals/EntityTitleStencil.vue';
import Formula from './components/atoms/visuals/Formula.vue';
import GradeBadge from './components/atoms/visuals/GradeBadge.vue';
import Icon from './components/atoms/visuals/Icon.vue';
import IconStencil from './components/atoms/visuals/IconStencil.vue';
import InfoPill from './components/atoms/visuals/InfoPill.vue';
import Number from './components/atoms/visuals/Number.vue';
import NumberBasic from './components/atoms/visuals/NumberBasic.vue';
import NumberStencil from './components/atoms/visuals/NumberStencil.vue';
import ProgressBar from './components/atoms/visuals/ProgressBar.vue';
import Rating from './components/atoms/visuals/Rating.vue';
import RatingStencil from './components/atoms/visuals/RatingStencil.vue';
import Score from './components/atoms/visuals/Score.vue';
import ScoreStencil from './components/atoms/visuals/ScoreStencil.vue';
import SectionTitle from './components/atoms/visuals/SectionTitle.vue';
import Smiley from './components/atoms/visuals/Smiley.vue';
import SmileyStencil from './components/atoms/visuals/SmileyStencil.vue';
import Sparkline from './components/atoms/visuals/Sparkline.vue';
import Text from './components/atoms/visuals/Text.vue';
import TextStencil from './components/atoms/visuals/TextStencil.vue';
import Trend from './components/atoms/visuals/Trend.vue';
import TruncatedText from './components/atoms/visuals/TruncatedText.vue';
import TruncatedTitle from './components/atoms/visuals/TruncatedTitle.vue';
import StatusIndicator from './components/atoms/visuals/StatusIndicator.vue';
import AiBadge from './components/atoms/visuals/AiBadge.vue';
import NewBadge from './components/atoms/visuals/NewBadge.vue';
export {
    Badge, Breakdown, Dot, EntityTitle,
    EntityTitleStencil, Formula, GradeBadge, Icon, IconStencil,
    InfoPill, Number, NumberBasic, NumberStencil,
    ProgressBar, Rating, RatingStencil, Score, ScoreStencil,
    SectionTitle, Smiley, SmileyStencil, Sparkline, Text,
    TextStencil, Trend, TruncatedText, TruncatedTitle, StatusIndicator,
    AiBadge, NewBadge
}
const ATOMS_VISUALS_COMP_MAP = [
    {key: 'mead-ai-badge', comp: AiBadge},
    {key: 'mead-badge', comp: Badge},
    {key: 'mead-breakdown', comp: Breakdown},
    {key: 'mead-dot', comp: Dot},
    {key: 'mead-entity-title', comp: EntityTitle},
    {key: 'mead-entity-title-stencil', comp: EntityTitleStencil},
    {key: 'mead-formula', comp: Formula},
    {key: 'mead-grade-badge', comp: GradeBadge},
    {key: 'mead-icon', comp: Icon},
    {key: 'mead-icon-stencil', comp: IconStencil},
    {key: 'mead-info-pill', comp: InfoPill},
    {key: 'mead-new-badge', comp: NewBadge},
    {key: 'mead-number', comp: Number},
    {key: 'mead-number-basic', comp: NumberBasic},
    {key: 'mead-number-stencil', comp: NumberStencil},
    {key: 'mead-progress-bar', comp: ProgressBar},
    {key: 'mead-rating', comp: Rating},
    {key: 'mead-rating-stencil', comp: RatingStencil},
    {key: 'mead-score', comp: Score},
    {key: 'mead-score-stencil', comp: ScoreStencil},
    {key: 'mead-section-title', comp: SectionTitle},
    {key: 'mead-smiley', comp: Smiley},
    {key: 'mead-smiley-stencil', comp: SmileyStencil},
    {key: 'mead-sparkline', comp: Sparkline},
    {key: 'mead-text', comp: Text},
    {key: 'mead-text-stencil', comp: TextStencil},
    {key: 'mead-trend', comp: Trend},
    {key: 'mead-truncated-text', comp: TruncatedText},
    {key: 'mead-truncated-title', comp: TruncatedTitle},
    {key: 'mead-status-indicator', comp: StatusIndicator}
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> Atoms
//

import BasicTabDisplay from './components/atoms/BasicTabDisplay.vue';
import BreadcrumbsList from './components/atoms/BreadcrumbsList.vue';
import AthButton from './components/atoms/Button.vue';
import ButtonV2 from './components/atoms/ButtonV2.vue';
import ButtonGroup from './components/atoms/ButtonGroup.vue';
import ButtonIcon from './components/atoms/ButtonIcon.vue';
import ButtonPill from './components/atoms/ButtonPill.vue';
import CollapseIcon from './components/atoms/CollapseIcon.vue';
import CollapseTrigger from './components/atoms/CollapseTrigger.vue';
import Collapsible from './components/atoms/Collapsible.vue';
import Empty from './components/atoms/Empty.vue';
import FakeButtonIcon from './components/atoms/FakeButtonIcon.vue';
import FilterWrapper from './components/atoms/FilterWrapper.vue';
import Lazy from './components/atoms/Lazy.vue';
import Link from './components/atoms/Link.vue';
import Loader from './components/atoms/Loader.vue';
import LoaderBar from './components/atoms/LoaderBar.vue';
import Panel from './components/atoms/Panel.vue';
import PopoverTrigger from './components/atoms/PopoverTrigger.vue';
import Sort from './components/atoms/Sort.vue';
import StickyHeader from './components/atoms/StickyHeader.vue';
import Warning from './components/atoms/Warning.vue';
import ItemsList from './components/atoms/ItemsList.vue';
export {
    BasicTabDisplay, BreadcrumbsList, AthButton, ButtonV2, ButtonGroup,
    ButtonIcon, ButtonPill, CollapseIcon, CollapseTrigger,
    Collapsible, Empty, FakeButtonIcon, FilterWrapper,
    Lazy, Link, Loader, LoaderBar,
    Panel, PopoverTrigger, Sort, StickyHeader,
    Warning, ItemsList,
}
const ATOMS_COMP_MAP = [
    {key: 'mead-basic-tab-display', comp: BasicTabDisplay},
    {key: 'mead-breadcrumbs-list', comp: BreadcrumbsList},
    {key: 'mead-button', comp: AthButton},
    {key: 'mead-button-v2', comp: ButtonV2},
    {key: 'mead-button-group', comp: ButtonGroup},
    {key: 'mead-button-icon', comp: ButtonIcon},
    {key: 'mead-button-pill', comp: ButtonPill},
    {key: 'mead-collapse-icon', comp: CollapseIcon},
    {key: 'mead-collapse-trigger', comp: CollapseTrigger},
    {key: 'mead-collapsible', comp: Collapsible},
    {key: 'mead-empty', comp: Empty},
    {key: 'mead-fake-button-icon', comp: FakeButtonIcon},
    {key: 'mead-filter-wrapper', comp: FilterWrapper},
    {key: 'mead-lazy', comp: Lazy},
    {key: 'mead-link', comp: Link},
    {key: 'mead-loader', comp: Loader},
    {key: 'mead-loader-bar', comp: LoaderBar},
    {key: 'mead-panel', comp: Panel},
    {key: 'mead-popover-trigger', comp: PopoverTrigger},
    {key: 'mead-sort', comp: Sort},
    {key: 'mead-sticky-header', comp: StickyHeader},
    {key: 'mead-warning', comp: Warning},
    {key: 'mead-items-list', comp: ItemsList},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> globals
//

import GlobalModal from './components/globals/GlobalModal.vue';
import GlobalPopover from './components/globals/GlobalPopover.vue';
import GlobalPopoverController from './components/globals/GlobalPopoverController.vue';
import GlobalPopoverMixin from './components/globals/GlobalPopoverMixin';
export {GlobalModal, GlobalPopover, GlobalPopoverController, GlobalPopoverMixin}
const GLOBALS_COMP_MAP = [
    {key: 'mead-global-modal-container', comp: GlobalModal},
    {key: 'mead-global-popover-container', comp: GlobalPopover},
    {key: 'mead-global-popover-controller', comp: GlobalPopoverController},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> AgGrid
//

import AgGridConversionTable from './components/molecules/ag-grid-table/AgGridConversionTable.vue';
import AgGridTable from './components/molecules/ag-grid-table/AgGridTable.vue';
import AgGridComponent from './components/molecules/ag-grid-table/AgGridComponent.vue';
import AgGridBadge from './components/molecules/ag-grid-table/AgGridBadge.vue';
export {AgGridConversionTable, AgGridTable, AgGridComponent, AgGridBadge}
const AG_GRID_COMP_MAP = [
    {key: 'mead-ag-grid-conversion-table', comp: AgGridConversionTable},
    {key: 'mead-ag-grid-table', comp: AgGridTable},
    {key: 'mead-ag-grid-component', comp: AgGridComponent},
    {key: 'mead-ag-grid-badge', comp: AgGridBadge},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> Dashboard
//

import Dashboard from './components/molecules/dashboard/Dashboard.vue';
import DashboardItemConfigMixin from './components/molecules/dashboard/mixins/DashboardItemConfigMixin.js';
import DashboardItemMixin from './components/molecules/dashboard/mixins/DashboardItemMixin.js';
import MultiConfigDisplay from './components/molecules/dashboard/configuration/MultiConfigDisplay.vue';
import DashboardAddEditModal from './components/molecules/dashboard/modals/DashboardAddEditModal.vue';
import DashboardItemFilterBar from './components/molecules/dashboard/configuration/filter-bar/DashboardItemFilterBar.vue';
export {
    Dashboard,
    DashboardItemConfigMixin,
    DashboardItemMixin,
    MultiConfigDisplay,
    DashboardAddEditModal,
    DashboardItemFilterBar
}
const DASHBOARD_COMP_MAP = [
    {key: 'mead-dashboard', comp: Dashboard},
    {key: 'mead-multi-config-display', comp: MultiConfigDisplay},
    {key: 'mead-dashboard-add-edit-modal', comp: DashboardAddEditModal},
    {key: 'mead-dashboard-item-filter-bar', comp: DashboardItemFilterBar}
] as const satisfies readonly ComponentKeyMapping[]


//
// Components -> molecules -> DropdownCategorized
//

import DropdownCategorized from './components/molecules/dropdown-categorized/DropdownCategorized.vue';
export {DropdownCategorized}
const DROPDOWN_CATEGORIZED_COMP_MAP = [
    {key: 'mead-dropdown-categorized', comp: DropdownCategorized},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> List
//

import List from './components/molecules/list/List.vue';
export {List}
const LIST_COMP_MAP = [
    {key: 'mead-list', comp: List},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> big-number-list
//
import BigNumberList from './components/molecules/big-number-list/BigNumberList.vue';
export {BigNumberList}
const BIG_NUMBER_LIST_COMP_MAP = [
    {key: 'mead-big-number-list', comp: BigNumberList},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> modals
//

import Blank from './components/molecules/modal-styles/Blank.vue';
import Info from './components/molecules/modal-styles/Info.vue';
import StandardModal from './components/molecules/modal-styles/Standard.vue';
export {Blank, Info, StandardModal as Standard}
const MODALS_COMP_MAP = [
    {key: 'mead-blank-modal', comp: Blank},
    {key: 'mead-info-modal', comp: Info},
    {key: 'mead-standard-modal', comp: StandardModal},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> multi-step-filter
//

import MultiStepFilter from './components/molecules/multi-step-filter/MultiStepFilter.vue';
import MultiFilter from './components/molecules/multi-filter/MultiFilter.vue';
import MultiStepFilterConfigList
    from './components/molecules/multi-step-filter-config-list/MultiStepFilterConfigList.vue';
import MultiStepFilterConfigListItemWidget
    from './components/molecules/multi-step-filter-config-list/MultiStepFilterConfigListItemWidget.vue';
import MultiStepFilterDropdown from './components/molecules/multi-step-filter-dropdown/MultiStepFilterDropdown.vue';
import MultiStepFilterList from './components/molecules/multi-step-filter-list/MultiStepFilterList.vue';
import MultiStepFilterListItem from './components/molecules/multi-step-filter-list/MultiStepFilterListItem.vue';
import MultiStepFilterPopover from './components/molecules/multi-step-filter-popover/MultiStepFilterPopover.vue';
export {
    MultiStepFilter, MultiFilter,
    MultiStepFilterConfigList, MultiStepFilterConfigListItemWidget,
    MultiStepFilterDropdown,
    MultiStepFilterList, MultiStepFilterListItem,
    MultiStepFilterPopover
}
const MULTI_STEP_FILTER_COMP_MAP = [
    {key: 'mead-multi-step-filter', comp: MultiStepFilter},
    {key: 'mead-multi-filter', comp: MultiFilter},
    {key: 'mead-multi-step-filter-config-list', comp: MultiStepFilterConfigList},
    {key: 'mead-multi-step-filter-config-list-item-widget', comp: MultiStepFilterConfigListItemWidget},
    {key: 'mead-multi-step-filter-dropdown', comp: MultiStepFilterDropdown},
    {key: 'mead-multi-step-filter-list', comp: MultiStepFilterList},
    {key: 'mead-multi-step-filter-list-item', comp: MultiStepFilterListItem},
    {key: 'mead-multi-step-filter-popover', comp: MultiStepFilterPopover},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> popovers
//

import FilterPopover from './components/molecules/popovers/Filter.vue';
export {FilterPopover}
const POPOVERS_COMP_MAP = [
    {key: 'mead-filter-popover', comp: FilterPopover},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> standalone_modals
//

import CheckboxConfirmModal from './components/molecules/standalone_modals/CheckboxConfirmModal.vue';
import ConfirmModal from './components/molecules/standalone_modals/ConfirmModal.vue';
import FormModal from './components/molecules/standalone_modals/FormModal.vue';
import InfoModal from './components/molecules/standalone_modals/InfoModal.vue';
import InputConfirmModal from './components/molecules/standalone_modals/InputConfirmModal.vue';
import Modal from './components/molecules/standalone_modals/Modal.vue';
import ToggleModal from './components/molecules/standalone_modals/ToggleModal.vue';
export {
    CheckboxConfirmModal,
    ConfirmModal,
    FormModal,
    InfoModal,
    InputConfirmModal,
    Modal,
    ToggleModal,
}
const STANDALONE_MODALS_COMP_MAP = [
    {key: 'mead-standalone-checkbox-confirm-modal', comp: CheckboxConfirmModal},
    {key: 'mead-standalone-confirm-modal', comp: ConfirmModal},
    {key: 'mead-standalone-form-modal', comp: FormModal},
    {key: 'mead-standalone-info-modal', comp: InfoModal},
    {key: 'mead-standalone-input-confirm-modal', comp: InputConfirmModal},
    {key: 'mead-standalone-modal', comp: Modal},
    {key: 'mead-standalone-toggle-modal', comp: ToggleModal},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules -> table
//

import Table from './components/molecules/table/Table.vue';
import TableHeader from './components/molecules/table/TableHeader.vue';
import TableRow from './components/molecules/table/TableRow.vue';
import TableRowContainer from './components/molecules/table/TableRowContainer.vue';
import TableRowStencil from './components/molecules/table/TableRowStencil.vue';
import TableSuperHeader from './components/molecules/table/TableSuperHeader.vue';
export {Table, TableHeader, TableRow, TableRowContainer, TableRowStencil, TableSuperHeader}
const TABLE_COMP_MAP = [
    {key: 'mead-table', comp: Table},
    {key: 'mead-table-header', comp: TableHeader},
    {key: 'mead-table-row', comp: TableRow},
    {key: 'mead-table-row-container', comp: TableRowContainer},
    {key: 'mead-table-row-stencil', comp: TableRowStencil},
    {key: 'mead-table-super-header', comp: TableSuperHeader},
] as const satisfies readonly ComponentKeyMapping[]

//
// Components -> molecules
//

import AppBanner from './components/molecules/AppBanner.vue';
import Dropdown from './components/molecules/Dropdown.vue';
import FlyOut from './components/molecules/FlyOut.vue';
import FlyOutPanel from './components/molecules/FlyOutPanel.vue';
import Pagination from './components/molecules/Pagination.vue';
import PanelHeader from './components/molecules/PanelHeader.vue';
import PanelWidget from './components/molecules/PanelWidget.vue';
import Entity from './components/molecules/Entity.vue';
import Sidebar from './components/molecules/Sidebar.vue';
export {AppBanner, Dropdown, FlyOut, FlyOutPanel, Pagination, PanelHeader, PanelWidget, Entity, Sidebar}
const MOLECULES_COMP_MAP = [
    {key: 'mead-app-banner', comp: AppBanner},
    {key: 'mead-dropdown', comp: Dropdown},
    {key: 'mead-fly-out', comp: FlyOut},
    {key: 'mead-fly-out-panel', comp: FlyOutPanel},
    {key: 'mead-pagination', comp: Pagination},
    {key: 'mead-panel-header', comp: PanelHeader},
    {key: 'mead-panel-widget', comp: PanelWidget},
    {key: 'mead-entity', comp: Entity},
    {key: 'mead-sidebar', comp: Sidebar},
] as const satisfies readonly ComponentKeyMapping[]

//
// Directives
//

import MoveDirective from './directives/Move.js';
import ScrollFadeHorizontalDirective from './directives/ScrollFadeHorizontal.js';
import ScrollFadeVerticalDirective from './directives/ScrollFadeVertical.js';
import ScrollOverlayDirective from './directives/ScrollOverlay.js';
import SwipeDirective from './directives/Swipe.js';
import HorizontalWheelScrollDirective from './directives/HorizontalWheelScroll.js';
export {
    MoveDirective,
    ScrollFadeHorizontalDirective,
    ScrollFadeVerticalDirective,
    ScrollOverlayDirective,
    SwipeDirective,
    HorizontalWheelScrollDirective
}

//
// Mixins
//

import UIMobile from './mixins/UIMobile';
export {UIMobile};

/**
 * Component map of global tag names that will be used for
 * all mead components.
 *
 * Some tag names differ from the file name as we
 * are working on better names but need to stick to old names
 * for backwards compatibility for now.
 *
 * Also please prefix all components with "mead-"
 */
const COMPONENT_MAP = [
    ...ATOMS_ENTITIES_COMP_MAP,
    ...ATOMS_FORMS_COMP_MAP,
    ...ATOMS_STENCILS_COMP_MAP,
    ...ATOMS_VISUALS_COMP_MAP,
    ...ATOMS_COMP_MAP,
    ...GLOBALS_COMP_MAP,
    ...AG_GRID_COMP_MAP,
    ...DASHBOARD_COMP_MAP,
    ...DROPDOWN_CATEGORIZED_COMP_MAP,
    ...LIST_COMP_MAP,
    ...BIG_NUMBER_LIST_COMP_MAP,
    ...MODALS_COMP_MAP,
    ...MULTI_STEP_FILTER_COMP_MAP,
    ...POPOVERS_COMP_MAP,
    ...STANDALONE_MODALS_COMP_MAP,
    ...TABLE_COMP_MAP,
    ...MOLECULES_COMP_MAP,
] as const satisfies readonly ComponentKeyMapping[]

/**
 * Derives the tag -> component type map straight from COMPONENT_MAP so it can
 * never drift from what bindVueComponents() actually registers at runtime.
 *
 * This powers HTML tag autocomplete (Volar/Vue - Official) for every
 * "mead-*" component, since Vue.component() calls are invisible to the
 * type checker unless declared here.
 */
export type MeadComponentEntry = typeof COMPONENT_MAP[number];
export type MeadComponentKey = MeadComponentEntry['key'];
export type MeadGlobalComponents = {
    [E in MeadComponentEntry as E['key']]: E['comp'];
};
declare module 'vue' {
    // This is Vue's own module-augmentation pattern (also used by vue-router,
    // Pinia, etc.); it must stay an `interface extends` since only an
    // `interface` merges with the ambient `GlobalComponents` declaration.
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    interface GlobalComponents extends MeadGlobalComponents {}
}

const SUPPORTED_FILTERS = {
    MEAD_TRANSLATE: 'athT',
    MEAD_HUMANIZE_NUMBER: 'athNumber'
}

class MeadCore implements PluginObject<void>, IMeadCore {
    private _installed:boolean = false;
    private _componentsInstalled:boolean = false;
    private _filtersInstalled:boolean = false;
    private _directivesInstalled:boolean = false;
    private _componentKeyList:MeadComponentKey[] = [];
    private _componentMap:Map<MeadComponentKey, any> = new Map<MeadComponentKey, any>();
    private _docgenMap:Record<string, any> | undefined = undefined;

    /**
     * Returns true/false if the full Mead suite has been installed
     */
    get installed() { return this._installed; }

    /**
     * Returns true/false if the full components have been installed
     */
    get componentsInstalled() { return this._componentsInstalled; }

    /**
     * Returns true/false if the full filters have been installed
     */
    get filtersInstalled() { return this._filtersInstalled; }

    /**
     * Returns true/false if the full directives have been installed
     */
    get directivesInstalled() { return this._directivesInstalled; }

    /**
     * Returns a list of all bound component keys
     */
    get componentKeys() { return this._componentKeyList; }

    /**
     * Fetch an individual component. This is mainly intended
     * for storybook usage.
     *
     * Only works if install or bindVueComponents has been called once.
     * @param key
     */
    getComponent<K extends MeadComponentKey> (key:K): MeadGlobalComponents[K] | undefined {
        if (this._componentMap.has(key)) {
            return this._componentMap.get(key);
        }
    }

    /**
     * Registers pre-generated vue-docgen-api documentation (see
     * scripts/vite-plugin-bundle-docgen.js's bundle/mead.docgen.json
     * output) for every globally-registered component, stamping each entry's
     * `__docgenInfo` onto the matching component - this is what tools like
     * Storybook's Controls panel normally read off a component to show its
     * props/events/slots, but they can't get it from getComponent() the
     * usual way (a build-time loader statically analyzing a `.vue` file),
     * since these components come from this already-built bundle instead.
     *
     * Deliberately opt-in and not bundled/called automatically: the docgen
     * data itself is meaningful extra weight production consumers of this
     * bundle don't need, so it's the caller's responsibility to fetch
     * mead.docgen.json and pass it in (e.g. only from a Storybook
     * preview setup), rather than mead loading and applying it by default.
     * @param docgenMap {key: vue-docgen-api ComponentDoc}
     */
    registerDocGen (docgenMap: Record<string, any>) {
        this._docgenMap = docgenMap;
        this._applyDocgen();
    }

    /**
     * Stamps any registered docgen info (see registerDocGen()) onto whatever
     * components are currently bound. Safe to call regardless of whether
     * registerDocGen() or bindVueComponents() ran first.
     */
    private _applyDocgen () {
        if (!this._docgenMap) return;
        for (const key of Object.keys(this._docgenMap)) {
            const component = this._componentMap.get(key);
            if (component) component.__docgenInfo = this._docgenMap[key];
        }
    }

    /**
     * Create a Mead global and a MeadCommon global on the window.
     * Mead will be this class, and MeadCommon will be the entire
     * typescript export directory.
     */
    mountGlobals () {
        if (typeof window !== 'undefined') {
            //  Assigned with Object.assign so this compiles against any Window declaration an app uses,
            //  including @aretheyhappy/mead-types/globals, whose classes are declared separately from Mead's
            Object.assign(window, {Mead: this, MeadCommon});
        } else {
            console.error('Mead.mountGlobals: Unable to bind Mead and MeadCommon');
        }
    }

    /**
     * Globally bind the entirety of Mead
     *
     * will create a Mead global and a MeadCommon global.
     * Mead will be this class, and MeadCommon will be the entire
     * typescript export directory.
     * @param vue
     */
    install (vue: typeof Vue) {
        if (this._installed) return;

        this.mountGlobals();

        this.bindVueComponents(vue);
        this.bindDefaultFilters(vue);
        this.bindAllDirectives(vue);

        MeadCommon.NotificationService.install();

        this._installed = true;
    }

    /**
     * Bind all vue components
     * @param vue
     */
    bindVueComponents (vue: typeof Vue) {
        if (this._componentsInstalled) return;

        this._componentKeyList = [];
        for (const componentItem of COMPONENT_MAP) {
            this._componentKeyList.push(componentItem.key);
            this._componentMap.set(componentItem.key, componentItem.comp);
            vue.component(componentItem.key, componentItem.comp);
        }

        this._componentsInstalled = true;
        this._applyDocgen();
    }

    /**
     * Bind default filters that Mead depends on
     * @param vue
     */
    bindDefaultFilters (vue: typeof Vue) {
        if (this._filtersInstalled) return;

        vue.filter(SUPPORTED_FILTERS.MEAD_TRANSLATE, (val:string, params = {}) => MeadCommon.I18N.go(val, params));
        vue.filter(SUPPORTED_FILTERS.MEAD_HUMANIZE_NUMBER, (val: number | string) => humanizeNumber(val));

        this._filtersInstalled = true;
    }

    /**
     * Bind all directives exported by Mead
     */
    bindAllDirectives (vue: typeof Vue) {
        if (this._directivesInstalled) return;

        ScrollOverlayDirective.bind(vue);
        SwipeDirective.bind(vue);
        MoveDirective.bind(vue);
        ScrollFadeVerticalDirective.bind(vue);
        ScrollFadeHorizontalDirective.bind(vue);
        HorizontalWheelScrollDirective.bind(vue);

        this._directivesInstalled = true;
    }

    //
    // Mixin Exports
    //

    get GlobalPopoverMixin() { return GlobalPopoverMixin; }
    get DashboardItemConfigMixin() { return DashboardItemConfigMixin; }
    get DashboardItemMixin() { return DashboardItemMixin; }
    get UIMobileMixin() { return UIMobile; }
}

const Mead = new MeadCore()
export { MeadCore };
export default Mead;